class CartSource {
    constructor(API) {
        this.API = API;
    }

    async list(data) {
        return await this.API.get('/index.php?route=api/cart', {
            params: { ...(data || {}), version: 2 }
        })
    }

    async add(product_id, options = null) {
        return await this.API.post("/index.php?route=api/cart/add&version=2", {
            product_id: product_id,
            option: options
        })
    }

    async update(cart_id, quantity) {
        return await this.API.post("/index.php?route=api/cart/edit&version=2", {
            cart_id: cart_id,
            quantity: quantity
        })
    }

    async remove(cart_id) {
        return await this.API.post("/index.php?route=api/cart/remove&version=2", {
            cart_id: cart_id
        })
    }
    async removeAll() {
        return await this.API.post("/index.php?route=api/cart/clear&version=2")
    }
}

export default CartSource
